$(function() {

    $("[data-show]").on("click", function(event) {
        let $this = $(this);
        let $target = $this.data("show");

        $($target).addClass("active");
        $("body").addClass("no-scroll");
    });

    $("[data-close]").on("click", function(event) {
        let $this = $(this);
        let $target = $this.data("close");

        $($target).removeClass("active");
        $("body").removeClass("no-scroll");
    });


    $(".sidebar__form").on("click", function(event) {
        $(this).removeClass("active");
        $("body").removeClass("no-scroll");
    });

    $(".sidebar__form-wrapper").on("click", (event) => {
        event.stopPropagation();
    });


});